export const laboratorioAccionesRoles = {
  sideNavActions: {
    laboratorio: ['Admin', 'CompoundingAdmin', 'CompoundingChemist'],
    laboratoryData: ['Admin', 'CompoundingAdmin', 'CompoundingChemist'],
    laboratoryTest: ['Admin', 'CompoundingAdmin', 'CompoundingChemist'],
    testometricReport: [],
  },
};
